export const classifierTabsValue = {
  new_classification: "New Classification",
  classified_products: "Classified Products",
};

export const classifierTabs = [
  {
    name: "New Classification",
    value: "new_classification",
  },
  {
    name: "Classified Products",
    value: "classified_products",
  },
];

export const generateColor = (name, isDark = false) => {
  const safeName = name || "";
  const hash = safeName.split("").reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  if (isDark) {
    const h = hash % 360;
    return `hsl(${h}, 70%, 35%)`;
  } else {
    const h = hash % 360;
    return `hsl(${h}, 70%, 85%)`;
  }
};

export const getInitials = (string = "") => {
  if (!string || !string?.trim()) return;
  const nameString = string.trim();
  const names = nameString.split(" ");
  const initials = names[0]?.[0]?.toUpperCase() || "";

  if (names.length > 1) {
    return initials + names[names.length - 1][0].toUpperCase();
  }
  return initials;
};
